import React, { Component } from 'react';

import { withState } from 'recompose';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import withStyles from '@mui/styles/withStyles';

import Tooltip from 'components/Common/Tooltip';

import styles from './styles';

@withStyles(styles)
@withState('anchor', 'setAnchor', null)
export default class WithPopover extends Component {
  render() {
    const {
      classes,
      anchor,
      setAnchor,
      popover = () => null,
      placement = 'bottom-start',
      render = () => null,
      disabled = false,
      disabledMessage = 'Disabled',
      messagePlacement = 'top',
      persistent = false,
      onPopoverClose = () => null,
      enabledMessage = '',
      ...rest
    } = this.props;

    return (
      <>
        {disabled ? (
          <Tooltip placement={messagePlacement} title={disabledMessage}>
            {render({ setAnchor, anchor })}
          </Tooltip>
        ) : (
          <Tooltip placement={messagePlacement} title={enabledMessage}>
            {render({ setAnchor, anchor })}
          </Tooltip>
        )}

        {!disabled && (
          <Popper
            open={Boolean(anchor)}
            anchorEl={anchor}
            anchorReference="anchorEl"
            onClose={() => setAnchor(null)}
            placement={placement}
            popperOptions={{
              modifiers: {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'scrollParent',
                },
              },
            }}
            disablePortal
            style={{ zIndex: 9999, marginTop: 8 }}
            {...rest}
          >
            <ClickAwayListener
              onClickAway={e => {
                e.preventDefault();
                e.stopPropagation();

                if (!persistent) {
                  setAnchor(null);
                  onPopoverClose();
                }
              }}
            >
              <Paper className={classes.paper}>{popover({ setAnchor })}</Paper>
            </ClickAwayListener>
          </Popper>
        )}
      </>
    );
  }
}
